import { combineReducers, configureStore } from "@reduxjs/toolkit";
import ChallengeSetupReducer from "./Redux/ChallengeSetup/ChallengeSetupReducer";
import ChallengeMainReducer from "./Redux/ChallengeMain/ChallengeMainReducer";
import ChallengeOverviewReducer from "./Redux/ChallengeOverview/ChallengeOverviewReducer";
import ChallengeRulesReducer from "./Redux/ChallengeRules/ChallengeRulesReducer";
import ChallengePerformanceReducer from "./Redux/ChallengePerformance/ChallengePerformanceReducer";
import ChallengeTradesReducer from "./Redux/ChallengeTrades/ChallengeTradesReducer";
import ScrollVariablesSlice from "./Redux/ScrollVariables/ScrollVariablesReducer";
import ProfileReducer from "./Redux/Profile/ProfileReducer";
import InvoiceReducer from "./Redux/CryptoChill/CrytochillReducer";
import NotificationsReducer from "./Redux/Notifications/NotificationsReducer";
import PaymentPurchaseReducer from "./Redux/PaymentsPurchase/PaymentsPurchaseReducers";
import CertificatesReducer from "./Redux/Certificates/CertificateReducer";
import CalendarReducer from "./Redux/Calendar/CalendarReducer";

const RootReducer = combineReducers({
  ScrollVariablesSlice: ScrollVariablesSlice,
  ChallengeSetupReducer: ChallengeSetupReducer,
  challengeMainReducer: ChallengeMainReducer,
  ChallengeOverviewReducer: ChallengeOverviewReducer,
  ChallengeRulesReducer: ChallengeRulesReducer,
  ChallengePerformanceReducer: ChallengePerformanceReducer,
  ChallengeTradesReducer: ChallengeTradesReducer,
  ProfileReducer: ProfileReducer,
  InvoiceReducer: InvoiceReducer,
  NotificationsReducer: NotificationsReducer,
  PaymentPurchaseReducer: PaymentPurchaseReducer,
  CertificatesReducer: CertificatesReducer,
  CalendarReducer: CalendarReducer,
});

export const Store = configureStore({
  reducer: RootReducer,
  devTools: process.env.NODE_ENV !== "production",
});
